var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { Component } from 'react';

import SearchResults from "../../Connections/components/SearchResults";

import SearchInput from "../../Layout/SearchInput";
import debounce from "../../utils/debounce";
import { RequestParams } from "../../utils/RequestParams";

import Immutable from 'immutable';
import SearchApi from "../../Search/SearchAPI";













export class SearchEntities extends Component {
  constructor(props) {
    super(props);
    this.state = { searchResults: Immutable.fromJS([]), searching: false, touched: false };
    this.onSelect = this.onSelect.bind(this);
    this.onChange = this.onChange.bind(this);
    this.search = this.search.bind(this);
  }

  componentDidMount() {
    if (this.props.initialSearchTerm) {
      this.search(this.props.initialSearchTerm);
    }
  }

  onSelect(_sharedId, entity) {
    this.props.onSelect(entity);
  }

  search(searchTerm) {
    this.setState({ searching: true });
    const requestParams = new RequestParams({
      searchTerm,
      fields: ['title'],
      includeUnpublished: true
    });

    return SearchApi.search(requestParams).then(
    ({ rows: searchResults }) => {
      this.setState({
        searchResults: Immutable.fromJS(searchResults),
        searching: false
      });
      this.props.onFinishSearch(searchTerm);
    });

  }

  onChange(e) {
    this.setState({ touched: true });
    const searchTerm = e.target.value;
    return debounce(this.search, 400)(searchTerm);
  }

  render() {
    const { searchResults, searching } = this.state;
    return /*#__PURE__*/(
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("div", { className: "search-box" }, void 0, /*#__PURE__*/
      _jsx(SearchInput, {
        onChange: this.onChange,
        value: !this.state.touched ? this.props.initialSearchTerm : undefined })), /*#__PURE__*/


      _jsx(SearchResults, { results: searchResults, searching: searching, onClick: this.onSelect })));


  }
}